import {
  getCycleTypesUrl,
  getCyclesUrl,
  getGoalsUrl,
  updateCycleTypeUrl,
  updateCyclesUrl,
  updateGoalUrl,
  updateObjectiveUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class CyclesService {
  static getCycles = () => {
    // get cycles and their associated goals
    return getRequest(getCyclesUrl());
  };

  static getCycleById = (id) => {
    return getRequest(updateCyclesUrl(id));
  };

  static createCycle = (cycle) => {
    // will create cycle AND associated goals
    return postRequest(getCyclesUrl(), cycle);
  };

  static updateCycle = (cycle) => {
    return putRequest(updateCyclesUrl(cycle.id), cycle);
  };

  static deleteCycle = (cycle) => {
    return deleteRequest(updateCyclesUrl(cycle.id), cycle);
  };
}

export class GoalsService {
  static getGoals = () => {
    // Will get goals that aren't associated with a cycle
    // return getRequest(getGoalsUrl(), params);
  };

  // can probably just use getCycleById for this - should return goals
  // static getGoalsByCycle = (cycleId) => {
  //   // return getRequest(getCyclesUrl(cycleId));
  // };

  static getGoalById = (goalId) => {
    return getRequest(updateGoalUrl(goalId));
  };

  static deleteGoalObjective = (objective) => {
    return deleteRequest(updateObjectiveUrl(objective.id), objective);
  };

  static updateGoalObjective = (objective) => {
    // update a goal that is or is not associated with a cycle
    return putRequest(updateObjectiveUrl(objective.id), objective);
  };

  static createGoal = (goal) => {
    // will create a goal not associated with a cycle
    return postRequest(getGoalsUrl(), goal);
  };

  static updateGoal = (goal) => {
    // update a goal that is or is not associated with a cycle
    return putRequest(updateGoalUrl(goal.id), goal);
  };

  static deleteGoal = (goal) => {
    return deleteRequest(updateGoalUrl(goal.id), goal);
  };
}

export class CycleTypeService {
  static getCycleTypes = () => {
    return getRequest(getCycleTypesUrl());
  };

  static createCycleType = (cycleType) => {
    return postRequest(getCycleTypesUrl(), cycleType);
  };

  static getCycleTypeById = (cycleTypeId) => {
    return getRequest(updateCycleTypeUrl(cycleTypeId));
  };
  static updateCycleType = (cycleType) => {
    return putRequest(updateCycleTypeUrl(cycleType.id), cycleType);
  };

  static deleteCycleType = (cycleTypeId) => {
    return deleteRequest(updateCycleTypeUrl(cycleTypeId));
  };
}
